export default __webpack_public_path__ + "static/media/settings.3009b372.svg";